/**
 * This component can be removed whenever we are sure we are not going back to the legacy Account Setup screen
 * (three steps on the left column with the first one being active)
 */

import * as React from 'react';
import useConfig from '@sdk/config/useConfig';
import { SetupOrgOnboardingSteps } from '@sdk/authentication/types';
import laptop from '@sdk/assets/images/web-login/signup-laptop.png';
import SideImageScreen from '@sdk/login/components/SideImageScreen';

import FullPageContainer from '@web/components/FullPageContainer';
import { StyledSideImage, OrgSetupContainer } from '@web/onboarding/styles';
import { NumberedStepsWrapper } from '@web/onboarding/steps/components/NumberedStepsWrapper';

type Props = {
  children: React.ReactNode;
  activeStep: SetupOrgOnboardingSteps;
  steps: SetupOrgOnboardingSteps[];
};

export const AccountStepWrapper = ({ steps, activeStep, children }: Props) => {
  const { FEATURE_FLAGS } = useConfig();

  return FEATURE_FLAGS.ONBOARDINNG_SELECT_POS_ENABLED ? (
    <FullPageContainer>
      <SideImageScreen image={<StyledSideImage src={laptop} />}>
        <OrgSetupContainer>{children}</OrgSetupContainer>
      </SideImageScreen>
    </FullPageContainer>
  ) : (
    <NumberedStepsWrapper steps={steps} activeStep={activeStep}>
      {children}
    </NumberedStepsWrapper>
  );
};
